<mat-progress-bar
  mode="indeterminate"
  *ngIf="!(!!aggregatedJobData)"
></mat-progress-bar>
<a
  [routerLink]="['/jobs/job/', jobItem.id, 'total-matches']"
  [queryParams]="{ category: associationLabel, offset: 0, redirect: 'true' }"
>
  <div class="dashboard-job-item">
    <common-mojo-card
      [elevation]="elevation"
      mojoContainerQuery
      xlSize='950'
    >
      <div class="job-container">
        <div class="detail">
          <p class="title mojo-blue-hover">
            {{jobItem.title}}
          </p>
          <div
            data-cy="job-item-remote-location"
            class="remote-chip"
            *ngIf="jobItem.remote"
          >
            <div class="label">REMOTE</div>
          </div>
          <p class="desc-text">Function:
            {{jobItem?.departments[0]?.hcmDepartmentFunction?.functionName}}
          </p>
          <p class="desc-text">Dept: {{jobItem?.departments[0]?.name}}</p>
          <div
            class="manager"
            *ngIf="jobItem.hiringManagers.length > 0; else noManagerPlaceholder"
          >
            <common-mojo-avatar
              [selectedPhotoShape]="avatarPhotoShape"
              [backgroundSize]="avatarBackgroundSizes"
              [initials]="jobItem.hiringManagers[0].firstName[0] + jobItem.hiringManagers[0].lastName[0]"
            >
            </common-mojo-avatar>
            <div class="manager-info">
              <p class="desc-text">Hiring manager</p>
              <p class="name">
                {{[jobItem.hiringManagers[0]?.firstName, jobItem.hiringManagers[0]?.lastName].join(' ')}}
              </p>
            </div>
          </div>
          <ng-template #noManagerPlaceholder>
            <div class="manager">
              <common-mojo-avatar
                [selectedPhotoShape]="avatarPhotoShape"
                [backgroundSize]="avatarBackgroundSizes"
              >
              </common-mojo-avatar>
              <div class="manager-info">
                <p class="desc-text">&ndash;&ndash;</p>
              </div>
            </div>
          </ng-template>
        </div>

        <div class="content">
          <div class="middle">
            <ng-content select="[middle]"></ng-content>
          </div>
          <div class="right">
            <ng-content select="[right]"></ng-content>
          </div>
        </div>
      </div>
    </common-mojo-card>
  </div>
</a>
